import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './feature/store';
import ThemeContext from "./context/ThemeContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import {persistStore} from 'redux-persist';

const root = ReactDOM.createRoot(document.getElementById('root'));

let persistor = persistStore(store);

root.render(

  <Provider store={store}>
 <PersistGate loading={null} persistor={persistor}>
    <ThemeContext>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GG_APP_ID || ""}>
        <App />
      </GoogleOAuthProvider>
    </ThemeContext>
    </PersistGate>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// Service worker for caching and updating react app
// At the end of the file


// // ... previous code ...

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', function () {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then(registration => {
//         console.log('ServiceWorker registration successful with scope: ', registration.scope);

//         registration.addEventListener('updatefound', () => {
//           // If there's an updated worker available, get it and listen for state changes
//           const newWorker = registration.installing;

//           newWorker.addEventListener('statechange', () => {
//             if (newWorker.state === 'installed') {
//               // When the service worker is installed and the user is online, reload the page to get the new version
//               if (navigator.onLine) {
//                 alert('A new version of this app is available. Loading new version...');
//                 window.location.reload();
//               }
//             }
//           });
//         });
//       })
//       .catch(err => {
//         console.log('ServiceWorker registration failed: ', err);
//       });
//   });
// }